module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Bawi Roof Restoration - Western Melbourne Roofing Experts","short_name":"Bawi Roof","start_url":"/","background_color":"#ffffff","theme_color":"#0B5FA5","display":"minimal-ui","icon":"src/images/Bawi Roof Logo.png","icon_options":{"purpose":"any maskable"},"cache_busting_mode":"none","legacy":true,"theme_color_in_head":true,"crossOrigin":"anonymous","include_favicon":true,"cacheDigest":null},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
